module.exports = __webpack_public_path__ + "static/Nana-404d863e8adbe7ba60174f70b37a8581.jpg";